// creates tooltip instances, centralizes step management to keep App.js clean and handles mapping logic. 
import React, { useEffect } from 'react';
import { useTutorial } from './useTutorial';
import TutorialTooltip from './TutorialTooltip';

const TutorialManager = ({ steps = [] }) => {
  const { 
    isActive, 
    setTutorialSteps, 
    flattenedSteps,
    currentStepIndex,
    currentSectionId,
    currentStepId
  } = useTutorial();

  useEffect(() => {
    if (steps && steps.length > 0) {
      setTutorialSteps(steps);
    }
  }, [steps, setTutorialSteps]);

  // Check conditions for rendering
  const canRender = isActive && flattenedSteps.length > 0;
  
  if (!canRender) {
    return null;
  }

  // Only render the current active tooltip
  const currentStepById = currentStepId
    ? flattenedSteps.find(
        step =>
          step.stepId === currentStepId &&
          (!currentSectionId || step.sectionId === currentSectionId)
      )
    : null;

  const currentStep = currentStepById || flattenedSteps[currentStepIndex];
  
  if (!currentStep) {
    return null;
  }

  return (
    <TutorialTooltip
      sectionId={currentStep.sectionId}
      stepId={currentStep.stepId}
      stepIndex={currentStepIndex}
      name={currentStep.name}
      content={currentStep.content}
      targetSelector={currentStep.targetSelector}
      position={currentStep.position || 'bottom'}
      action={currentStep.action || 'view'}
    />
  );
};

export default TutorialManager;